import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "0px 12px 0px 12px",
      height: "100%"
    },
    container: {
      flexDirection: "column",
      height: "100%",
      '& .userItem': {
        width: '100%',
        '&.heading': {
          paddingBottom: theme.spacing(2.5),
          '& p': {
            fontSize: 24,
            color: COLORS.BLACK,
            fontWeight: 600
          }
        },
        '&.content': {
          backgroundColor: COLORS.WHITE,
          //boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.04)",
          borderRadius: theme.spacing(1),
          height: "calc(100vh - 172px)",
          paddingTop: theme.spacing(1.5),
          '& .userIdLink': {
            margin: 'auto 0px',
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12
          },
          '& .userIdEmailVerified':{
            margin: 'auto 4px',
            padding: 0,
            width: '15px',
            height: '15px',
            fill: COLORS.SEA_GREEN,
          },

        }
      }
    },
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    progressBar: {
      width: '75%',
      marginRight: theme.spacing(1),
    },
    progressText: {
      minWidth: 35,
    },
    linearProgressRoot: {
      height: "12px",
      borderRadius: "8px",
  },
  linearProgress: {
      marginTop: "8px",
  },
  linearProgressBarRoot: {
      borderRadius: 4,
      backgroundColor: COLORS.SECONDARY_DARK,
  },
  linearProgressColorDefault: {
      backgroundColor: COLORS.SECONDARY_DARK,
  },
  linearProgressBarColor: {
      backgroundColor: COLORS.LIGHT_PERSIAN_GREEN,
  },
  linearProgressBarColorInProgress: {
      backgroundColor: COLORS.PRIMARY_MAIN,
  },
    actionsHeader: {
      alignItems: "center",
      '& .actionItem': {
        cursor: "pointer",
        '& .icon': {
          padding: theme.spacing(0.25, 0.5, 0.25, 0.5)
        }
      }
    },
    dateRange:{
      fontSize: 12,
    },
    customDialogPaperPropsRoot: {
      width: 600,
      height: 350,
      margin: "auto",
      borderRadius: theme.spacing(1),
    },
    dialogDetailsContentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .contentItem": {
        "& p": {
          textAlign: "center",
          lineHeight: 1.2,
        },
        "&.heading": {
          padding: theme.spacing(0, 15.75, 5),
          "& p": {
            fontSize: 24,
            fontWeight: 600,
          },
        },
        "&.desc": {
          padding: theme.spacing(0, 2.5),
          "& p": {
            fontSize: 18,
            fontWeight: 400,
            "& .count": {
              fontWeight: 600,
            },
          },
        },
      },
    },
    dialogDetailsActionContainer: {
      justifyContent: "center",
      paddingBottom: theme.spacing(8.25),
      "& .dialogBtn": {
        "&.secondary": {
          paddingLeft: theme.spacing(8),
          paddingRight: theme.spacing(8),
          marginRight: theme.spacing(1),
        },
        "&.primary": {
          paddingLeft: theme.spacing(7.25),
          paddingRight: theme.spacing(7.25),
          marginLeft: theme.spacing(1),
        },
      },
    },
    filterSection:{
      padding: "20px 0px 12px",
      width: "auto",
      "& .icon": {
        cursor: "pointer",
        verticalAlign: "middle",
        fill: "none",
      },
  },
  filterFormWrapper:{
    display:'flex',
    gap: 24
}
  }),
);
